// Foundation
import 'poly-eshop4/eshop/ui/js/foundation/foundation';
import 'poly-eshop4/eshop/ui/js/foundation/breakpoints';

// Foundation extensions
import 'poly-eshop4/eshop/ui/js/extensions/autofocus';
import 'poly-eshop4/eshop/ui/js/extensions/offcanvas';
import 'poly-eshop4/eshop/ui/js/extensions/map';
import 'poly-eshop4/eshop/ui/js/extensions/recaptcha';

// Stores
// import 'poly-eshop4/eshop/ui/js/store/store';
import './store/store';

// Base
/* eslint-disable */
import 'poly-eshop4/eshop/ui/js/scanner';
import 'poly-eshop4/eshop/ui/js/confirm';
import 'poly-eshop4/eshop/ui/js/cookie';
import 'poly-eshop4/eshop/ui/js/add-to-cart';
// import 'poly-eshop4/eshop/ui/js/fastentry';
import 'poly-eshop4/eshop/ui/js/cart';
import 'poly-eshop4/eshop/ui/js/pending-cart';
import 'poly-eshop4/eshop/ui/js/checkout';
import 'poly-eshop4/eshop/ui/js/header';
import 'poly-eshop4/eshop/ui/js/items';
import 'poly-eshop4/eshop/ui/js/itemlist';
import 'poly-eshop4/eshop/ui/js/label';
import 'poly-eshop4/eshop/ui/js/autocomplete';
import 'poly-eshop4/eshop/ui/js/search';
import 'poly-eshop4/eshop/ui/js/shoppinglist';
import 'poly-eshop4/eshop/ui/js/registration';
import 'poly-eshop4/eshop/ui/js/oci';
import 'poly-eshop4/eshop/ui/js/account';
import 'poly-eshop4/eshop/ui/js/orderapproval';
import 'poly-eshop4/eshop/ui/js/object';
import 'poly-eshop4/eshop/ui/js/exporter';
import 'poly-eshop4/eshop/ui/js/news';
import 'poly-eshop4/eshop/ui/js/cms';
import 'poly-eshop4/eshop/ui/js/lazyload';
import 'poly-eshop4/eshop/ui/js/statistics';
import 'poly-eshop4/eshop/ui/js/table';
import 'poly-eshop4/eshop/ui/js/art-num-management';
import 'poly-eshop4/eshop/ui/js/orders';
import 'poly-eshop4/eshop/ui/js/comparisonlist';
import 'poly-eshop4/eshop/ui/js/cart-edit-mode';

// Payments
import 'poly-eshop4/eshop/ui/js/datatrans';

// Workarounds
import 'poly-eshop4/eshop/ui/js/workaround/stickyfill';
import 'poly-eshop4/eshop/ui/js/workaround/ios-label-for';
/* eslint-enable */

// Indivs
import './cart';
import './shoppinglists/objects';
import './fastentry';
import './flags';
import './price_info';
import './comparisonlist';
import './category-message';
import './feedback_form';
import './object_opening_from';
import './itemlist';
import './checkout';
import './article_num_management';
import './cms';
import './reels';
